import { articleLocaleContents } from "focus-content";
import useLocale from "hooks/useLocale";
import type { GetStaticPaths, GetStaticProps } from "next";
import { useRouter } from "next/router";
import { DefaultMDXProvider } from "../../components/default-mdx-provider";

export const getStaticPaths: GetStaticPaths = async () => {
  const locales = ["en", "fr", "es", "ru", "ar", "zh", "de"];

  return {
    paths: locales.flatMap((locale) =>
      Object.keys(articleLocaleContents.en).map((focus) => ({
        params: { focus },
        locale,
      })),
    ),
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps = async () => {
  return { props: {} };
};

export default function Focus() {
  const locale = useLocale();
  const { query } = useRouter();
  const focus = query.focus as string;
  const localeMap = articleLocaleContents[locale];
  const { default: Content, frontmatter } = localeMap[focus];

  return (
    <DefaultMDXProvider frontmatter={frontmatter}>
      <Content />
    </DefaultMDXProvider>
  );
}
